import React from 'react';

interface SpinsLimitFieldProps {
  spinsPerWhatsapp: number;
  blockByIp: boolean;
  onChange: (value: number) => void;
  onBlockByIpChange: (value: boolean) => void;
}

const SpinsLimitField: React.FC<SpinsLimitFieldProps> = ({ spinsPerWhatsapp, blockByIp, onChange, onBlockByIpChange }) => {
  return (
    <div>
      <label className="block text-xs font-bold uppercase tracking-wider text-tinta">
        Quantas vezes pode girar? (por WhatsApp)
      </label>
      <input
        type="number"
        min="0"
        value={spinsPerWhatsapp || 0}
        onChange={(e) => onChange(parseInt(e.target.value) || 0)}
        className="mt-1 block w-full bg-white border border-tinta/15 rounded-lg px-3 py-2.5 text-sm text-tinta placeholder:text-tinta-soft/70 placeholder:italic focus:outline-none focus:ring-2 focus:ring-bordo/40 focus:border-bordo transition-colors"
        placeholder="0"
      />
      <p className="mt-1 text-xs text-tinta-soft italic">
        Cada pessoa pode girar este número de vezes. 0 = sem limite
      </p>

      {spinsPerWhatsapp > 0 && (
        <div className="mt-3 pl-4 border-l-2 border-bordo/30">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={blockByIp}
              onChange={(e) => onBlockByIpChange(e.target.checked)}
              className="rounded border-tinta/30 text-bordo focus:ring-bordo/40 focus:ring-offset-0 cursor-pointer"
            />
            <span className="text-sm font-bold text-tinta">
              Bloquear também por IP
            </span>
            <span className="text-xs text-tinta-soft italic" title="Impede que o mesmo dispositivo/conexão gire mais vezes usando WhatsApp diferente">
              (anti-fraude)
            </span>
          </label>
        </div>
      )}
    </div>
  );
};

export default SpinsLimitField;
